function creerLigneListe(
    cpt,
    id,
    nom,
    adresse,
    ville,
    cp,
    pays,
    currently_open,
    horaire_today,
    distance,
    marqueur,
    picture_filtre,
    magasinId,
    stock,
    stockStatus,
    stock_quantity,
    clientId,
    favorite,
    beContacted,
    flag_available,
    url,
    shop_filter,
    telephone,
    query,
    lat,
    lng
) {
    currently_open = parseFloat(currently_open);
    const li = document.createElement("li");
    li.id = id;
    li.dataset.lng = lng;
    li.dataset.lat = lat;

    li.className = "elem-list-store";

    if (lat != "" && lng != "" && !$("body.product_page").length) {
        li.setAttribute("onclick", "geolocGoto('" + lat + "', '" + lng + "')");
    }

    if (favorite == "1") {
        choose_fav = Translator.translate("actual_favorite_store");
    } else {
        choose_fav = Translator.translate("choose_as_favorite_store");
    }

    /***** Product stock infos *****/
    if (stock_quantity == "undefined" || stock_quantity == "") {
        stock_status_msg = "unknow_stock";
    } else {
        const in_stock = stock_quantity >= 6 && stock_quantity <= 9999;
        const limited_stock = stock_quantity >= 1 && stock_quantity <= 5;
        const not_in_stock = stock_quantity == 0;
        const to_be_confirmed_stock = stock_quantity == 10000;
        const can_be_ordered_stock = stock_quantity == 11000;

        const stock_status_msg = "";
        if (in_stock) {
            stock_status_msg = "in_stock";
        }
        if (limited_stock) {
            stock_status_msg = "limited_stock";
        }
        if (not_in_stock) {
            stock_status_msg = "not_in_stock";
        }
        if (to_be_confirmed_stock) {
            stock_status_msg = "to_be_confirmed_stock";
        }
        if (can_be_ordered_stock) {
            stock_status_msg = "can_be_ordered_stock";
        }
    }

    const info_horaire_today = !horaire_today ? Translator.translate("store_closed") : horaire_today;

    const class_horaire_today = currently_open ? "store-open" : "store-closed";

    let ligneListe =
        `<div class="sore-item">`;

        ligneListe +=
            `<h2 class="title">${nom}</h2>` +
            `<span class="store-address">${adresse}</span>` +
            `<span class="store-zip">${cp}</span>` +
            `<span class="store-city">${ville}</span>` +
            `<span class="store-country">${pays}</span>` +
            `<a class="store-tel" href="tel:${telephone}">${telephone}</a>`;

    const is_page_product = $("body.product_page").length == 1;

    if ((info_horaire_today !== "" && currently_open) || (!currently_open && horaire_today)) {
        ligneListe += `<span class="horaire-today ${class_horaire_today}">${info_horaire_today}</span>`;
    }

    if (document.getElementById("produit_id")) {
        /***** Product stock infos msg *****/
        if (stock != "undefined") {
            ligneListe +=
            `<p class="stock_status ${stock_status_msg}">${Translator.translate(stock_status_msg + "_msg")}</p>`;
        }
    }

    if (is_page_product) {
        if (beContacted == 1) {
            var nom_mag = nom.replace(/'/g, "\\'");
            ligneListe +=
                '<div class="availableTxt store_more" onclick="handleChange(\'' +
                id +
                "','" +
                nom_mag +
                "')\">" +
                "<span>" +
                txt_available_mag +
                "</span>" +
                "</div>";
        }
    }

    ligneListe += `<a href="${path_relative_root + url}" class="store-detail-link" target="_blank">${Translator.translate("consult_store_detail")}</a>`;

    ligneListe += `</div>`;

    li.innerHTML = ligneListe;

    li.addEventListener("click", function () {
        google.maps.event.trigger(marqueur, "click");
    });

    return li;
}

function creerMarqueur(
    point,
    nom,
    adresse,
    ville,
    cp,
    pays,
    horaire,
    telephone,
    email,
    site,
    image_mag,
    type_mag,
    cpt,
    magasin_id,
    url,
    distance,
    currently_open,
    horaire_today
) {
    const http = new RegExp("^http://", "g");
    const markerImage = document.createElement("img");

    markerImage.src = pinImg;

    const marqueur = new google.maps.marker.AdvancedMarkerElement({
        position: point,
        content: markerImage,
    });

    marqueur.magasin_id = magasin_id;
    nom = $.trim(nom);
    adresse = $.trim(adresse);
    ville = $.trim(ville);
    cp = $.trim(cp);
    pays = $.trim(pays);
    horaire = $.trim(horaire);
    telephone = $.trim(telephone);
    email = $.trim(email);
    site = $.trim(site);
    distance = Math.round(distance);
    const info_horaire_today = horaire_today ? horaire_today : '';
    const class_horaire_today = currently_open ? "store-open" : "store-closed";

    let ligneListe =
        `<div class="store-infos">` +
        `<a href="${url}" class="store-name">${nom}</a>` +
        `<span class="store-address">${adresse}</span>` +
        `<span class="store-zip">${cp}</span>` +
        `<span class="store-city">${ville}</span>`;

    if (horaire_today != "") {
        ligneListe += `<span class="horaire-today ${class_horaire_today}">${info_horaire_today}</span>`;
    }

    // Tooltip more infos & go to store link
    ligneListe +=
        `<div class="store-tooltip-buttons">
            <a class="geolocalisation_link" target="_blank" href="https://maps.google.fr/maps?daddr=${point.lat()},${point.lng()}">${Translator.translate("store_tooltip_go_store")}</a>
            <a href="${url}">${Translator.translate("store_tooltip_detail")}</a>
        </div>`;

    ligneListe += `</div>`;

    google.maps.event.addListener(marqueur, "click", function () {
        // selected store coordinates
        var storePosition = new google.maps.LatLng(point.lat(), point.lng());
        // center map on marker
        maCarte.setCenter(storePosition);
        // map animation on marker switch
        maCarte.panTo(storePosition);

        if (!infowindow) {
            infowindow = new google.maps.InfoWindow();
            infowindow.setContent(ligneListe);
            infowindow.open(maCarte, marqueur);
        } else {
            infowindow.setContent(ligneListe);
            infowindow.open(maCarte, marqueur);
        }
    });

    var detail_store_panel = document.getElementById("store_id_dataLayer");
    detail_store_panel.textContent = magasin_id;

    markersArray.push(marqueur);

    return marqueur;
}